import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { CandidatoService } from '../candidato.service';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { Observable } from 'rxjs/Observable';
import { Util } from '../../shared/util';
import { ConfirmationService } from 'primeng/primeng';
import { Router, ActivatedRoute } from '@angular/router';
import { StatusCandidato } from '../../../models/statusCandidato';
import { AbstractControl, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';

@Component({
  selector: 'emprego-na-pistagerenciar-status-aluno',
  templateUrl: './gerenciar-status-aluno.component.html',
  styleUrls: ['./gerenciar-status-aluno.component.css']
})
export class GerenciarStatusAlunoComponent extends WebPage implements OnInit {
  candidato;
  idCandidato;
  statusCandidatoList;
  form: FormGroup;

  arquivosToRemove = new FormArray([]);
  uploadUrl: string;

  @ViewChild('cpfConsultado') cpfConsultado: ElementRef;

  get arquivos() { return this.form.get('arquivos') as FormArray; }
  get IdCandidato() { return this.form.get('idCandidato'); }
  get LiberarVaga() { return this.form.get('liberarVaga'); }

  constructor(
    messageService: MessageService,
    private candidatoService: CandidatoService,
    private _router: Router,
    private route: ActivatedRoute,
    private arquivoService: ArquivoService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService
  ) {
    super(messageService);

    this.uploadUrl = this.arquivoService.uploadUrl + 'notaTecnica';
    this.route.paramMap.subscribe(params =>
      this.idCandidato = params.get('idCandidato')
    );

    this.form = fb.group({
      idCandidato: [null],
      idStatusCandidato: [null, Validators.required],
      liberarVaga: [null],
      justificativa: [null, Validators.required],
      arquivos: new FormArray([])
    });

  }

  ngOnInit() {
    this.candidatoService
      .getStatusCandidatoPodemSerAlterados()
      .finally(() => (this.isLoading = false))
      .subscribe(
        statusCandidatoList => {
          this.statusCandidatoList = statusCandidatoList;
          this.candidatoService
                  .getFull(this.idCandidato)
                  .finally(() => (this.isLoading = false))
                  .subscribe(
                    candidato => {
                      this.candidato = candidato;

                      if (this.candidato != null) {
                        this.form.controls['idCandidato'].setValue(this.candidato.idCandidato);
                      }
                      this.carregarStatusPorOfertaPretendida(this.candidato.ofertaPretendida);
                    },
                    error => this.gerenciaErro(error)
                  );
        },
        error => this.gerenciaErro(error)
      );


  }
  carregarStatusPorOfertaPretendida(ofertaPretendida: number):void{
    console.log('Selecao do Candidato ' + ofertaPretendida);
    switch(ofertaPretendida){
      case 1: //1 HABILITACAO
        this.statusCandidatoList = this.statusCandidatoList.filter(
          (x) =>  x.idStatusCandidato.toUpperCase() == 'EF2BC378-C6DE-4C74-BACC-F160BCED667E' ||
          x.idStatusCandidato.toUpperCase() == 'D214DE2C-3210-4755-9716-DF7C2D1F1D5F' ||
          x.idStatusCandidato.toUpperCase() == 'C56785F0-6E14-4E4C-AD4E-9E0553B59298' ||
          x.idStatusCandidato.toUpperCase() == '09E02BBE-E6A0-44E9-8BBE-9FCAAA69643F' ||
          x.idStatusCandidato.toUpperCase() == 'BA91CBE0-7127-4BF9-B0DA-171DFC7A2F45' ||
          x.idStatusCandidato.toUpperCase() == '6EE0761E-9A05-4925-AC4E-9FB51A4BAB29' ||
          x.idStatusCandidato.toUpperCase() == 'D2A37592-817F-432F-8EB0-F5FBAB3F3D68' ||
          x.idStatusCandidato.toUpperCase() == 'A3C5B5A4-A0B0-46A1-99D1-3E52B2014F36' ||
          x.idStatusCandidato.toUpperCase() == 'C79776B7-BF44-4478-B4CC-69ABC402BFCE' ||
          x.idStatusCandidato.toUpperCase() == '73A62B28-E2A0-4415-8CA5-D2A13EA95279' ||
          x.idStatusCandidato.toUpperCase() == '424D2C6B-E948-4310-9D2E-A66937987ABC' ||
          x.idStatusCandidato.toUpperCase() == '0AA10A3C-9DE3-49A0-B909-2A62D404E236' ||
          x.idStatusCandidato.toUpperCase() == 'A757FAD3-8E0B-489A-B4FF-3638E56BFAC0' ||
          x.idStatusCandidato.toUpperCase() == '70DF9A3C-AA95-411A-A5C2-E39BE9E6311B' ||
          x.idStatusCandidato.toUpperCase() == '28DB159F-29FC-47AF-87D3-BA41F2EB57CC' ||
          x.idStatusCandidato.toUpperCase() == '5D4D0AF7-C279-45BC-9AB0-1C3EF25DE677' ||
          x.idStatusCandidato.toUpperCase() == 'C8811628-F533-40BB-B93F-DE934D66E12C' ||
          x.idStatusCandidato.toUpperCase() == '64665C3B-FB45-404E-93D9-38E49F0A301B' ||
          x.idStatusCandidato.toUpperCase() == '312DEFB6-A514-4D4A-A4E7-5AD05EF5E684' ||
          x.idStatusCandidato.toUpperCase() == '0A60CD77-D46E-4FEF-AC23-C0E8C9AA4C76' ||
          x.idStatusCandidato.toUpperCase() == 'D9F6E44B-7010-45ED-AF5B-14F59E064E59' ||
          x.idStatusCandidato.toUpperCase() == 'CB124057-3067-4260-80B6-6918A2AB1423' ||
          x.idStatusCandidato.toUpperCase() == '22490F2D-51EA-47AF-84B8-7A6958EEEAC3' ||
          x.idStatusCandidato.toUpperCase() == '44360CED-377F-4CA8-9463-0A3C31B7EEFD' ||
          x.idStatusCandidato.toUpperCase() == '9CAEB9A7-C291-4AB9-AF8F-39178E5E9860')
        break;
      case 2: //ADICAO A/B
        this.statusCandidatoList = this.statusCandidatoList.filter(
          (x) =>  x.idStatusCandidato.toUpperCase() == 'EF2BC378-C6DE-4C74-BACC-F160BCED667E' ||
          x.idStatusCandidato.toUpperCase() == 'D214DE2C-3210-4755-9716-DF7C2D1F1D5F' ||
          x.idStatusCandidato.toUpperCase() == 'C56785F0-6E14-4E4C-AD4E-9E0553B59298' ||
          x.idStatusCandidato.toUpperCase() == '09E02BBE-E6A0-44E9-8BBE-9FCAAA69643F' ||
          x.idStatusCandidato.toUpperCase() == 'BA91CBE0-7127-4BF9-B0DA-171DFC7A2F45' ||
          x.idStatusCandidato.toUpperCase() == '6EE0761E-9A05-4925-AC4E-9FB51A4BAB29' ||
          x.idStatusCandidato.toUpperCase() == 'D2A37592-817F-432F-8EB0-F5FBAB3F3D68' ||
          x.idStatusCandidato.toUpperCase() == 'A3C5B5A4-A0B0-46A1-99D1-3E52B2014F36' ||
          x.idStatusCandidato.toUpperCase() == 'C79776B7-BF44-4478-B4CC-69ABC402BFCE' ||
          x.idStatusCandidato.toUpperCase() == '73A62B28-E2A0-4415-8CA5-D2A13EA95279' ||
          x.idStatusCandidato.toUpperCase() == '424D2C6B-E948-4310-9D2E-A66937987ABC' ||
          x.idStatusCandidato.toUpperCase() == '0AA10A3C-9DE3-49A0-B909-2A62D404E236' ||
          x.idStatusCandidato.toUpperCase() == '0A60CD77-D46E-4FEF-AC23-C0E8C9AA4C76' ||
          x.idStatusCandidato.toUpperCase() == 'D9F6E44B-7010-45ED-AF5B-14F59E064E59' ||
          x.idStatusCandidato.toUpperCase() == 'CB124057-3067-4260-80B6-6918A2AB1423' ||
          x.idStatusCandidato.toUpperCase() == '22490F2D-51EA-47AF-84B8-7A6958EEEAC3' ||
          x.idStatusCandidato.toUpperCase() == '44360CED-377F-4CA8-9463-0A3C31B7EEFD' ||
          x.idStatusCandidato.toUpperCase() == '9CAEB9A7-C291-4AB9-AF8F-39178E5E9860')
        break;
      case 3: //MUDANCA D/E
        this.statusCandidatoList = this.statusCandidatoList.filter(
          (x) =>  x.idStatusCandidato.toUpperCase() == 'EF2BC378-C6DE-4C74-BACC-F160BCED667E' ||
          x.idStatusCandidato.toUpperCase() == 'D214DE2C-3210-4755-9716-DF7C2D1F1D5F' ||
          x.idStatusCandidato.toUpperCase() == '183A6E69-7BEE-4328-A5B5-7B22AEBC4DE5' ||
          x.idStatusCandidato.toUpperCase() == '190C978C-BABF-41CB-B308-87CDD809B2EE' ||
          x.idStatusCandidato.toUpperCase() == 'D30AFB7E-478B-435D-8C56-3ACCAABA293A' ||
          x.idStatusCandidato.toUpperCase() == 'C56785F0-6E14-4E4C-AD4E-9E0553B59298' ||
          x.idStatusCandidato.toUpperCase() == '09E02BBE-E6A0-44E9-8BBE-9FCAAA69643F' ||
          x.idStatusCandidato.toUpperCase() == 'BA91CBE0-7127-4BF9-B0DA-171DFC7A2F45' ||
          x.idStatusCandidato.toUpperCase() == '6EE0761E-9A05-4925-AC4E-9FB51A4BAB29' ||
          x.idStatusCandidato.toUpperCase() == 'D2A37592-817F-432F-8EB0-F5FBAB3F3D68' ||
          x.idStatusCandidato.toUpperCase() == 'A3C5B5A4-A0B0-46A1-99D1-3E52B2014F36' ||
          x.idStatusCandidato.toUpperCase() == 'C79776B7-BF44-4478-B4CC-69ABC402BFCE' ||
          x.idStatusCandidato.toUpperCase() == '73A62B28-E2A0-4415-8CA5-D2A13EA95279' ||
          x.idStatusCandidato.toUpperCase() == '424D2C6B-E948-4310-9D2E-A66937987ABC' ||
          x.idStatusCandidato.toUpperCase() == '0AA10A3C-9DE3-49A0-B909-2A62D404E236' ||
          x.idStatusCandidato.toUpperCase() == '0A60CD77-D46E-4FEF-AC23-C0E8C9AA4C76' ||
          x.idStatusCandidato.toUpperCase() == 'D9F6E44B-7010-45ED-AF5B-14F59E064E59' ||
          x.idStatusCandidato.toUpperCase() == 'CB124057-3067-4260-80B6-6918A2AB1423' ||
          x.idStatusCandidato.toUpperCase() == '22490F2D-51EA-47AF-84B8-7A6958EEEAC3' ||
          x.idStatusCandidato.toUpperCase() == '44360CED-377F-4CA8-9463-0A3C31B7EEFD' ||
          x.idStatusCandidato.toUpperCase() == '9CAEB9A7-C291-4AB9-AF8F-39178E5E9860' ||
          x.idStatusCandidato.toUpperCase() == 'C2178A18-5BF3-4C30-9134-58B4A09F5F70')
        break;
      case 4: //MOTOFRETE
         this.statusCandidatoList = this.statusCandidatoList.filter(
          (x) =>  x.idStatusCandidato.toUpperCase() == 'EF2BC378-C6DE-4C74-BACC-F160BCED667E' ||
          x.idStatusCandidato.toUpperCase() == 'D214DE2C-3210-4755-9716-DF7C2D1F1D5F' ||
          x.idStatusCandidato.toUpperCase() == 'C56785F0-6E14-4E4C-AD4E-9E0553B59298' ||
          x.idStatusCandidato.toUpperCase() == '09E02BBE-E6A0-44E9-8BBE-9FCAAA69643F' ||
          x.idStatusCandidato.toUpperCase() == 'BA91CBE0-7127-4BF9-B0DA-171DFC7A2F45' ||
          x.idStatusCandidato.toUpperCase() == '87DF03BB-A71E-48DA-8BBD-48808451DCE9' ||
          x.idStatusCandidato.toUpperCase() == '49BC35B2-0DB7-4848-BB86-5737DDD66293' ||
          x.idStatusCandidato.toUpperCase() == '33D2D4A8-2063-448E-95D8-7701A3EC5E70' ||
          x.idStatusCandidato.toUpperCase() == '0A60CD77-D46E-4FEF-AC23-C0E8C9AA4C76' ||
          x.idStatusCandidato.toUpperCase() == 'D9F6E44B-7010-45ED-AF5B-14F59E064E59' ||
          x.idStatusCandidato.toUpperCase() == 'CB124057-3067-4260-80B6-6918A2AB1423' ||
          x.idStatusCandidato.toUpperCase() == '22490F2D-51EA-47AF-84B8-7A6958EEEAC3' ||
          x.idStatusCandidato.toUpperCase() == '44360CED-377F-4CA8-9463-0A3C31B7EEFD' ||
          x.idStatusCandidato.toUpperCase() == '9CAEB9A7-C291-4AB9-AF8F-39178E5E9860' ||
          x.idStatusCandidato.toUpperCase() == 'C2178A18-5BF3-4C30-9134-58B4A09F5F70')

        break;
      default:
        break;
    }
    console.log('Lista ' + JSON.stringify(this.statusCandidatoList));
  }
  // Arquivos
  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }



  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    arquivos.forEach(arquivo =>
      this.arquivoService.removeArquivo(arquivo.value.idArquivo)
        .subscribe(() => {

        })
    );
  }



  cancelar() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.removeArquivosDoBanco(this.arquivos.controls);
        this.removeArquivosDoBanco(this.arquivosToRemove.controls);
        this._router.navigate(['/admin']);
      }
    });
  }

  submit() {
    if (this.form.value.arquivos.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'A nota técnica é obrigatória'
      });
      return;
    }
    if (!this.form.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Campo obrigatório não preenchido!'
      });
      return;
    }


    /*if (this.form.value.idStatusCandidato.toUpperCase() === !StatusCandidato.DesclassificadoPorOutroMotivo) {
      this.LiberarVaga.setValue(null);
    }*/

    this.confirmationService.confirm({
      message: 'Deseja mesmo alterar o status deste aluno?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
          this.candidatoService.alterarStatusCandidato(this.form.value)
          .subscribe(candidato => {
            this.messageService.add({
              severity: 'success',
              summary: 'Atenção',
              detail: 'Status Atualizado com sucesso!'
            });
            this._router.navigate(['/gerenciar-etapas']);
          },
          error => this.gerenciaErro(error));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/gerenciar-status-aluno/gerenciar-status-aluno.component.ts